import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Button,
  CardHeader,
  Collapse,
} from "reactstrap";
import { H5 } from "../../../AbstractElements";
import { formatRP, handleScrollToTop } from "../../../Utils/externalFunctions";
import UMOCheckboxSelect from "../../DataTableComponents/UMOCheckboxSelect";
import { FORM_TYPE } from "../../../Constant/FormType";
import {
  STATUS_DATA_TYPE,
  getStatusDataName,
} from "../../../Constant/StatusData";
import {
  DateInputField,
  InputField,
  SelectionField,
  TextAreaField,
} from "../../../CommonElements";

const StepSatu = (props) => {
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [selectedUMO, setSelectedUMO] = useState(null);
  const [umoOpt, setUmoOpt] = useState([]);
  useEffect(() => {
    if (props.formType === FORM_TYPE.Create) {
      props.formTransaksi.dibayar_oleh = "Edina Ayuningtyas";
      if (props.formTransaksi.nilai_transaksi < 25000000) {
        props.formTransaksi.disetujui_oleh = "Edina Ayuningtyas";
      } else {
        props.formTransaksi.disetujui_oleh = "Achmad Nizar Hidayanto";
      }
    }
  }, [props.formTransaksi.nilai_transaksi]);

  useEffect(() => {
    checkButton();
  }, [props.formTransaksi]);

  useEffect(() => {
    if (props.umoList) {
      const filteredUMO = filterUMO(props.umoList);
      const filteredUMONew = filteredUMO.map((item) => ({
        value: item.id,
        label:
          item.diajukan_oleh +
          " - " +
          "Rp. " +
          formatRP(item.nilai) +
          " - " +
          item.keterangan +
          " - " +
          getStatusDataName(item.id_status_umo, STATUS_DATA_TYPE.UMO),
        name: "id_um_list",
      }));

      setUmoOpt(filteredUMONew);
      updateDefaultUMO(filteredUMONew);
    }
  }, [props.umoList]);

  const updateDefaultUMO = async (umo) => {
    setSelectedUMO(
      umo.map((item) =>
        props.formTransaksi.id_um_list.includes(item.value) ? item : null
      )
    );
  };

  const handleCheckboxUMO = (list) => {
    if (list === null) {
      return;
    }
    setSelectedUMO(list);
    props.handleCheckboxUMO(list);
  };

  const filterUMO = (umoList) => {
    let filteredUMOList = [];
    umoList.map((umo) => {
      if (
        umo.id_status_umo === 4 &&
        (umo.transaksi.length === 0 ||
          umo.transaksi.includes(props.formTransaksi.id))
      ) {
        filteredUMOList.push(umo);
      } else if (props.formType === FORM_TYPE.Edit) {
        props.formTransaksi.id_um_list?.map((id_um) => {
          if (id_um === umo.id) {
            filteredUMOList.push(umo);
          }
        });
      }
    });
    return filteredUMOList;
  };

  const checkButton = () => {
    setIsButtonActive(
      props.formTransaksi.id_unit_kerja !== "" &&
        props.formTransaksi.tanggal_transaksi !== "" &&
        props.formTransaksi.nilai_transaksi !== "" &&
        props.formTransaksi.id_counterpart !== "" &&
        props.formTransaksi.vendor !== "" &&
        props.formTransaksi.dibayarkan_ke !== "" &&
        props.formTransaksi.keterangan !== ""
    );
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Form>
              <H5>
                <strong>Detail Transaksi</strong>
              </H5>
              <Row>
                <Col md={6}>
                  <SelectionField
                    state={props.formTransaksi}
                    label={"DPSJ"}
                    name={"id_unit_kerja"}
                    placeholder={"-------"}
                    defaultValue={props.formTransaksi.id_unit_kerja}
                    onChange={props.handleChange}
                    options={props.unitKerja}
                    optionsName={"nama_unit_kerja"}
                  />
                </Col>
                <Col md={6}>
                  <DateInputField
                    state={props.formTransaksi}
                    label={"Tanggal Transaksi"}
                    name={"tanggal_transaksi"}
                    defaultValue={props.formTransaksi.tanggal_transaksi}
                    onChange={props.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={props.formTransaksi}
                    label={"Nilai Transaksi (Rp)"}
                    name={"nilai_transaksi"}
                    placeholder={"Nilai Transaksi"}
                    onChange={props.handleChange}
                    value={props.formattedNilai}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={props.formTransaksi}
                    label={"Vendor / Supplier"}
                    name={"id_counterpart"}
                    placeholder={"Vendor"}
                    defaultValue={props.formTransaksi.id_counterpart}
                    onChange={props.handleChange}
                  />
                </Col>

                <Col md={6}>
                  <SelectionField
                    state={props.formTransaksi}
                    label={"Jenis Pembayaran"}
                    name={"kode_jenis_pembayaran"}
                    defaultValue={props.formTransaksi.kode_jenis_pembayaran}
                    placeholder={"-------"}
                    customOptions={props.jenisPembayaran.map((jenis) => {
                      return jenis.nama_jenis_pembayaran !== "UMK" ? (
                        props.formTransaksi?.kode_jenis_pembayaran ===
                        jenis.nama_jenis_pembayaran ? (
                          <>
                            <option
                              key={jenis.pk}
                              value={jenis.nama_jenis_pembayaran}
                              selected
                            >
                              {jenis.nama_jenis_pembayaran}
                            </option>
                          </>
                        ) : (
                          <>
                            <option
                              key={jenis.pk}
                              value={jenis.nama_jenis_pembayaran}
                            >
                              {jenis.nama_jenis_pembayaran}
                            </option>
                          </>
                        )
                      ) : null;
                    })}
                    onChange={props.handleChange}
                  />
                </Col>

                <Col md={6}>
                  <InputField
                    state={props.formTransaksi}
                    label={"Dibayar ke"}
                    name={"dibayarkan_ke"}
                    placeholder={"Dibayarkan ke"}
                    defaultValue={props.formTransaksi.dibayarkan_ke}
                    onChange={props.handleChange}
                  />
                </Col>

                <Collapse
                  isOpen={
                    props.formTransaksi.kode_jenis_pembayaran === "KO" && umoOpt
                  }
                >
                  <Col md={12} className={"pb-2"}>
                    <UMOCheckboxSelect
                      umoList={props.umoList}
                      selectedUMO={selectedUMO}
                      umoOpt={umoOpt}
                      handleCheckboxUMO={handleCheckboxUMO}
                      formTransaksi={props.formTransaksi}
                      formType={props.formType}
                    />
                  </Col>
                </Collapse>

                <Col md={12}>
                  <TextAreaField
                    state={props.formTransaksi}
                    label={"Keterangan"}
                    name={"keterangan"}
                    placeholder={"Keterangan"}
                    defaultValue={props.formTransaksi.keterangan}
                    onChange={props.handleChange}
                  />
                </Col>
              </Row>

              <CardHeader></CardHeader>
              <H5>
                <strong>Detail Transaksi</strong>
              </H5>
              <Row>
                <Col md={6}>
                  <DateInputField
                    state={props.formTransaksi}
                    label={"Tanggal Diajukan"}
                    name={"tanggal_diajukan"}
                    defaultValue={props.formTransaksi.tanggal_diajukan}
                    onChange={props.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={props.formTransaksi}
                    label={"Diajukan Oleh"}
                    name={"diajukan_oleh"}
                    placeholder={"Diajukan Oleh"}
                    defaultValue={props.formTransaksi.diajukan_oleh}
                    onChange={props.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={props.formTransaksi}
                    label={"Disetujui Oleh"}
                    name={"disetujui_oleh"}
                    placeholder={"Disetujui Oleh"}
                    defaultValue={props.formTransaksi.disetujui_oleh}
                    onChange={props.handleChange}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={props.formTransaksi}
                    label={"Dibayar Oleh"}
                    name={"dibayar_oleh"}
                    placeholder={"Dibayar Oleh"}
                    defaultValue={props.formTransaksi.dibayar_oleh}
                    onChange={props.handleChange}
                  />
                </Col>
              </Row>

              <div className="text-end">
                <Button
                  disabled={!isButtonActive}
                  onClick={() => {
                    props.nextStep();
                    handleScrollToTop();
                  }}
                >
                  Next
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default StepSatu;
